/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the VitalScoreApiConfiguration configuration object with a given root URL.
 */
export function provideVitalScoreApiConfiguration(rootUrl: string) {
  var config = new VitalScoreApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: VitalScoreApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class VitalScoreApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `VitalScoreModule.forRoot()`
 */
export interface VitalScoreApiConfigurationParams {
  rootUrl?: string;
}
